import React from "react";
import ErrorHandler from "../../../components/ErrorHandler/ErrorHandler.component";

interface ICustomSelectDropdownProps {
  name?: string;
  placeholder?: string;
  label?: string;
  errors?: any;
  maxLength?: undefined | number;
  defaultValue?: string | number;
  value?: string | number;
  minLength?: undefined | number;
  readOnly?: boolean;
  onChange?: any;
  min?: number;
  showRequiredIcon?: boolean;
  hasActionButton?: boolean;
  actionButtonText?: string;
  onClickActionButton?: () => void;
  extraLabel?: string;
  bottomLabel?: string;
  rows?: number;
}

const CustomSelectDropdown: React.FC<ICustomSelectDropdownProps> =
  React.forwardRef(
    (
      {
        name,
        children,
        label,
        errors,
        value,
        onChange,
        showRequiredIcon,
        extraLabel,
      },
      ref: any
    ) => {
      return (
        <>
          <div className="form-group">
            <div className="d-flex align-items-center">
              <label className="form-label">{label}</label>
              {showRequiredIcon && <sup className="ml-1 crimson">*</sup>}
              {extraLabel && extraLabel.length && (
                <label className="form-label ml-2">
                  <small className="crimson">{extraLabel}</small>
                </label>
              )}
            </div>
            <select
              className="form-control"
              name={name}
              ref={ref}
              value={value}
              onChange={onChange}
            >
              {children}
            </select>
            <ErrorHandler errors={errors} />
          </div>
        </>
      );
    }
  );

export default CustomSelectDropdown;
